export default {
    init() 
    {
        $('.mediareleaseitems .accordion-group .accordion-heading').click(function() 
        {

            
            if (jQuery(this).parent().hasClass("active"))
            {
                jQuery(this).parent().removeClass("active");

                return;
            } 

            jQuery('.mediareleaseitems .accordion-group').each(function () { 
                jQuery(this).removeClass("active");
            });

            jQuery(this).parent().addClass("active");


            
        
        });

        /*$('.mediareleaseitems .accordion-group .accordion-item-header').click(function() 
        {
            if (jQuery(this).parent().hasClass("active"))
            {
                jQuery(this).parent().removeClass("active");

                return;
            } 

            jQuery('.mediareleaseitems .accordion-group .accordion-item').each(function () { 
                jQuery(this).removeClass("active");
            });

            jQuery(this).parent().addClass("active");


        });*/


    },
    finalize() {
    // JavaScript to be fired on the home page, after the init JS
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/mediaCentre.js